module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/product-by-categories/product-by-categories.component.css
// module id = ./src/app/pages/product-by-categories/product-by-categories.component.css
// module chunks = main